import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Output, EventEmitter, Pipe, PipeTransform, Renderer2,AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common'
import { Subject, Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Directive, HostListener } from '@angular/core';
import { trigger, state, style, transition, animate, animation } from '@angular/animations';
import { SystemService } from '../../services/system.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { UsersService } from '../../services/users.service';
import { DropzoneComponent, DropzoneDirective, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';

import { MatTableDataSource } from '@angular/material/table';

@Component({
	selector: 'app-excel-mapper',
	templateUrl: './excel-mapper.component.html',
	styleUrls: ['./excel-mapper.component.scss']
})
export class ExcelMapperComponent implements OnInit {

	@Input() uploadColumns: any = false;
	@Input() mappingName: any = false;
	@Input() autoMap = false;   // opt-in: pre-guess column mappings from header names
	@Output() mappedData = new EventEmitter < any > ();
	
	files: any = [];
	inputdata: any = false;
	uploaddata: any = false;
	processing_recs = false;
	dataSource: any = false;
	reviewReady = false;
	from_reorder = false;
	poHelp = false;
	upload_error: any = false;
	issalesman = false;
	fieldMatch = true;
	config: any = false;
	tablemap: any = {};
	requiredOk: any = false;
	user: any = false;
	
	constructor(private route: ActivatedRoute, private location: Location, public router: Router, public cdr: ChangeDetectorRef, private globalSearchService: GlobalSearchService, private globalsService: GlobalsService, private fb: UntypedFormBuilder, private modalService: NgbModal, public systemService: SystemService) {

		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			this.user = this.globalSearchService.user;

			this.globalSearchService.user.subscribe(u => {

			})
		});

	}
	ngOnInit(): void {
		
	}
	
	onSelect(event) {
		this.files.push(...event.addedFiles);
		for (let i = 0; i < this.files.length; i++) {
			this.readFile(this.files[i]).then(fileContents => {
				//stuff

				const upload = {
					content: fileContents,
					name: event.addedFiles[0].name,
					mime: event.addedFiles[0].type,
				}

				this.systemService.excelUpload(upload).subscribe((results: any) => {
					this.uploaddata = results;
					this.reviewReady = true;
					this.files = [];
					if (this.autoMap) {
						this.autoMapColumns();
						this.checkMap();
					}
				});

			});
		}
	}

	onRemove(event) {
		this.files.splice(this.files.indexOf(event), 1);
		this.upload_error = false;
	}


	private async readFile(file: File): Promise < string | ArrayBuffer > {
		return new Promise < string | ArrayBuffer > ((resolve, reject) => {
			const reader = new FileReader();

			reader.onload = e => {
				return resolve((e.target as FileReader).result);
			};

			reader.onerror = e => {
				console.error(`FileReader failed on file ${file.name}.`);
				return reject(null);
			};

			if (!file) {
				return reject(null);
			}
			reader.readAsDataURL(file);
		});

		this.files = [];
	}
	
	returnMap(){
		const newmap = [];
		this.uploaddata.rows.forEach( (r) => {
	
			const rowdata = {};
			this.uploaddata.headers.forEach((c) => {
				let col = '';
				if(this.tablemap[c] != null){
					col = this.tablemap[c];
				} else {
					col = c;
				}
				rowdata[col] = r[c];
			});
			newmap.push(rowdata);
		});
		this.uploaddata = [];
		this.reviewReady = false;
		this.mappedData.emit(newmap);
	}
	
	checkMap(){
		const usedcols = [];
		this.requiredOk = true;
		this.uploadColumns.forEach((e) => {

			if(e.required && Object.values(this.tablemap).indexOf(e.column) < 0){
				this.requiredOk = false;
			}

		});
	}

	/** Pre-guess tablemap[header] = best destination column by header-name similarity. */
	private autoMapColumns(){
		const norm = (s: any) => String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]/g, '');
		const headers = (this.uploaddata && this.uploaddata.headers) ? this.uploaddata.headers : [];
		const taken: any = {};
		headers.forEach((h: any) => {
			if (this.tablemap[h] != null) { return; } // respect an existing pick
			const nh = norm(h);
			if (!nh) { return; }
			let best = null;
			let bestScore = 0;
			this.uploadColumns.forEach((c: any) => {
				if (taken[c.column]) { return; } // one source per destination
				const nc = norm(c.column);
				const nl = norm(c.label);
				let score = 0;
				if (nh === nc || nh === nl) { score = 1; }
				else if (nc && (nh.indexOf(nc) >= 0 || nc.indexOf(nh) >= 0)) { score = 0.8; }
				else if (nl && (nh.indexOf(nl) >= 0 || nl.indexOf(nh) >= 0)) { score = 0.75; }
				if (score > bestScore) { bestScore = score; best = c.column; }
			});
			if (best && bestScore >= 0.7) {
				this.tablemap[h] = best;
				taken[best] = true;
			}
		});
	}
}
